import { useState } from "react";
import AIProgressAnalysis from "../../components/analysis/AIProgressAnalysis";
import AITargetgroupAnalysis from "../../components/analysis/AITargetgroupAnalysis";
import SelectableGrid from "../../components/common/SelectableGrid";

// Deprecated page — the per-entity AI analyses moved to the deep-analysis pages
// (/deepanalysis/:type/:id). Only the not-yet-migrated AI analyses live here:
// target groups and overall progress.

const TABS = [
  { id: 'targetgroups', label: 'Doelgroepen' },
  { id: 'progress', label: 'Algehele voortgang' },
]

/**
 * Legacy "AI analyse" page. Hosts the deferred AI analyses that don't yet have
 * a deep-analysis anchor: target groups and overall progress. Migrated AI
 * analyses (activity, effect, research, open question) now live on the
 * deep-analysis pages.
 */
const AddAIAnalysis = () => {
  const [navigation, setNavigation] = useState("targetgroups");

  const renderAnalysis = () => {
    switch (navigation) {
      case "targetgroups":
        return <AITargetgroupAnalysis />;
      case "progress":
        return <AIProgressAnalysis />;
      default:
        return null;
    }
  };

  return (
    <div className="main">
      <div className="main-container">
        <div className="page-header">
          <h1>AI analyse uitvoeren</h1>
        </div>
        <SelectableGrid
          items={TABS}
          getId={(item) => item.id}
          getLabel={(item) => item.label}
          selectedId={navigation}
          onClick={setNavigation}
        />

        {renderAnalysis()}
      </div>
    </div>
  );
};

export default AddAIAnalysis
